import { ArrowLeft, LooksTwo } from "@mui/icons-material";
import { Box, styled, Typography } from "@mui/material";
import { COLORS } from "../../../ui/Theme";
import LooksOne from "@mui/icons-material/LooksOne";
import { ListDivider } from "../../../ui/ListStyles";
const Caption = styled("p")({
  fontSize: "12px",
  color: COLORS.GRAY,
  display: "flex",
  alignItems: "center",
  gap: "8px",
});
const DomesticMarketSpreadPriceFavoriteCategoryCard = ({ favorite }) => {
  const {
    industry1,
    field1,
    group1,
    company1,
    commodity1,
    industry2,
    field2,
    group2,
    company2,
    commodity2,
  } = favorite;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        flexWrap: "wrap",
        gap: "8px",
      }}
    >
      <Box>
        <Typography
          sx={{
            fontSize: "14px",
            fontWeight: 700,
            display: "flex",
            alignItems: "center",
            gap: 0.5,
          }}
        >
          <LooksOne sx={{ fontSize: "16px", color: COLORS.BLUE }} />
          {industry1}
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: "8px",
          }}
        >
          <Caption>
            {field1}
            {group1 && <ArrowLeft />}
          </Caption>

          <Caption>
            {group1}
            {company1 && <ArrowLeft />}
          </Caption>

          <Caption>
            {company1}
            {commodity1 && <ArrowLeft />}
          </Caption>

          <Caption>{commodity1}</Caption>
        </Box>
      </Box>
      <ListDivider />
      <Box>
        <Typography
          sx={{
            fontSize: "14px",
            fontWeight: 700,
            display: "flex",
            alignItems: "center",
            gap: 0.5,
          }}
        >
          <LooksOne sx={{ fontSize: "16px", color: COLORS.BLUE }} />
          {industry2}
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: "8px",
          }}
        >
          <Caption>
            {field2}
            {group2 && <ArrowLeft />}
          </Caption>

          <Caption>
            {group2}
            {company2 && <ArrowLeft />}
          </Caption>

          <Caption>
            {company2}
            {commodity2 && <ArrowLeft />}
          </Caption>

          <Caption>{commodity2}</Caption>
        </Box>
      </Box>
    </Box>
  );
};

export default DomesticMarketSpreadPriceFavoriteCategoryCard;
